<script>
  import Header from './Header.vue'
  import Wrapper from './Wrapper.vue'
  import Question from './Question.vue'
  import Pass from './Pass.vue'

  import {mapState, mapMutations} from 'vuex'

   /**
    * This _*BasePage*_ component is a mixin that encapsulates the common functionality found in the ##Page## Components
    * Functionality like mapping common vuex properties (pass, fail, title, explainer etc) and the common vuex mutations (pass, fail and reset (test))
    * It also maps the usersBrowser details from the browser module as this is required in troubleshooting camera and microphone issues
    */
  export default {

    name: 'BasePage',
    data () {
      return {
        vuexModule: 'basePage' // NB - There is no Vuex module called basePage. This property is inherited from the Component that uses this mixin
      }
    },

    components: {
      'question-header': Header,
      'question-wrapper': Wrapper,
      'question-text': Question,
      'pass-message': Pass
    },

    computed: {
      ...mapState({
        pass (state) {
          return state[this.vuexModule].pass
        },
        fail (state) {
          return state[this.vuexModule].fail
        },
        skip (state) {
          return state[this.vuexModule].skip
        },
        explainer (state) {
          return state[this.vuexModule].explainer
        },
        title (state) {
          return state[this.vuexModule].title
        },
        nextPage (state) {
          return state[this.vuexModule].nextPage
        },
        previousPage (state) {
          return state[this.vuexModule].previousPage
        },
        callToAction (state) {
          return state[this.vuexModule].callToAction
        },
        questionId (state) {
          return state[this.vuexModule].questionId
        }
      }),

      ...mapState('browser', {
        'usersBrowserName': 'usersBrowserName',
        'usersBrowserVersion': 'usersBrowserVersion'
      }),

      ...mapState('camera', {
        'camDisabled': 'disabled'
      }),

      ...mapState('microphone', {
        'micDisabled': 'disabled'
      })
    },

    methods: {

      ...mapMutations({
        passTest (commit, payload) {
          return commit(this.vuexModule + '/pass', payload)
        },

        failTest (commit, payload) {
          return commit(this.vuexModule + '/fail', payload)
        },

        skipTest (commit, payload) {
          return commit(this.vuexModule + '/skip', payload)
        },

        resetTest (commit, payload) {
          return commit(this.vuexModule + '/reset', payload)
        }
      }),

      statusMessage (specificData, error) {

        const gernericData = {
          'userId': this.config.user ? this.config.user.id : 0,
          'status': 'fail',
          'test': this.vuexModule,
          'browserName': this.usersBrowserName,
          'browserVersion': this.usersBrowserVersion
        }

        if (error) {
          gernericData.error = {
            'name': error.name,
            'message': error.message
          }
        }

        return Object.assign({}, gernericData, specificData)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
